<template>
    <v-container :style="cssProps">
        <h1 class="titulo mb-5">Política de Vendas</h1>

        <div class="v-card card-container">
            <stepper-politica-vendas :pagina="2" @voltarEtapa="onVoltarEtapa" class="mb-3"></stepper-politica-vendas>
            <div class="px-5 py-5 relative">
                <AditamentoButton :id-plano-venda="condicao_venda.id_plano_venda" :tipo-estilo-botao="1"></AditamentoButton>
                <h3 class="text--primary">Detalhes do grupo</h3>
                <div class="px-0 mt-5 mr-1 separator">
                    <v-row>
                        <v-col cols="2" class="px-5">
                            <p class="mb-0 ml-0 pl-0">Grupo</p>
                            <p class="text--primary font-weight-bold">
                                {{ getAdministradora() }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Situação grupo</p>
                            <p class="text--primary font-weight-bold">
                                {{
                                    condicao_venda.st_situacao === "A" ? "Andamento" : "Formação"
                                }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Número máximo de cotas</p>
                            <p class="text--primary font-weight-bold">
                                {{ condicao_venda.num_maximo_cotas }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Prazos</p>
                            <p class="text--primary font-weight-bold">
                                {{
                                    prazos_disponiveis.length > 0
                                        ? prazos_disponiveis.map((item) => item.prazo).join(" / ") +
                                            " meses"
                                        : "Nenhum prazo disponível para venda"
                                }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <p class="mb-0">Plano de Venda</p>
                            <p class="text--primary font-weight-bold">
                                {{
                                    condicao_venda.cd_plano_venda +
                                        " - " +
                                        condicao_venda.nm_plano_venda
                                }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Categoria do plano de venda</p>
                            <p class="text--primary font-weight-bold">
                                {{ condicao_venda.categoria }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Vagas</p>
                            <p class="text--primary font-weight-bold">
                                {{ condicao_venda.vagas }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <p class="mb-0">Assembleias Realizadas</p>
                            <p class="text--primary font-weight-bold">
                                {{ condicao_venda.assembleias_realizadas }}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                    </v-row>
                </div>
                <h3 class="text--primary mt-4">Filtro</h3>
                <v-row>
                    <v-col cols="6">
                        <m-text-field label="Pesquisar Bem:" v-model="filters.nome_bem" placeholder="Digite o código ou nome do bem"
                                      outlined />
                    </v-col>
                    <v-col cols="6">
                        <v-row class="align-center row-padding">
                            <v-col>
                                <MoneyTextField label="Valor da parcela:" placeholder="Valor mínimo" v-model="filters.vl_parcela_min"
                                                maxlength="10" outlined />
                            </v-col>
                            <p class="mb-0">a</p>
                            <v-col>
                                <MoneyTextField placeholder="Valor máximo" v-model="filters.vl_parcela_max" maxlength="10" outlined />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row class="align-center">
                            <v-col>
                                <MoneyTextField label="Valor do bem:" placeholder="Valor mínimo" v-model="filters.vl_bem_min"
                                                maxlength="10" outlined />
                            </v-col>
                            <p class="mb-0">a</p>
                            <v-col>
                                <MoneyTextField placeholder="Valor máximo" v-model="filters.vl_bem_max" maxlength="10" outlined />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <div class="d-flex justify-end">
                    <v-col cols="2">
                        <v-select item-text="nome_produto" item-value="id_produto" :items="ordenar" v-model="campo_ordenado"
                                  @change="ordenarValorBemCrescente" placeholder="Ordenar por" />
                    </v-col>
                    <v-btn color="secondary" class="mr-4" @click="limpar">Limpar Filtros</v-btn>
                    <v-btn color="primary" :disabled="prazos_disponiveis.length === 0" @click="filtrar">Filtrar</v-btn>
                </div>
            </div>
        </div>

        <v-simple-table class="table-bem-politica-vendas mt-5" fixed-header>
            <thead class="table-bem-politica-vendas_theader">
                <tr>
                    <th class="no-box-shadow fixed-column">
                    </th>
                    <th v-if="condicao_venda.st_situacao === 'A'" class="no-box-shadow"></th>
                    <th :colspan="prazos_disponiveis.length" class="text-center no-box-shadow" style="z-index:1">
                        PRAZOS
                    </th>
                </tr>
                <tr>
                    <!-- Se é grupo em andamento tem uma coluna a mais com os labels Furo e Diluição -->
                    <td class="fixed-column" id="fixed-header" v-resize="ajustarTamanhosResponsivosDoDataTable">
                        Bem
                    </td>
                    <td v-if="condicao_venda.st_situacao === 'A'"></td>
                    <td v-for="prazo in prazos_disponiveis" :key="prazo.prazo">
                        <p class="flex text-center">{{ prazo.prazo }} meses</p>
                    </td>
                    <td v-if="prazos_disponiveis.length === 0">
                        <p class="text-center">Nenhum prazo disponível para venda</p>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr class="tr-color" v-for="bem in bens" :key="bem.id_bem + '|' + bem.id_grupo + '|' + bem.id_plano_venda">
                    <td class="py-4 fixed-column" style='min-width:30%; width:20vw'>
                        <div class="d-flex bem-item">
                            <img class="img-bem" :src="`${ws}/compra/imagembem/${bem.id_bem}`" :alt="bem.nm_bem" />
                            <div class="d-flex justify-space-between ml-6" style="flex-direction: column">
                                <p class="mt-auto" style="color: #222222; font-weight: bold">
                                    Cód. Bem: {{ bem.cd_bem }}
                                </p>
                                <div class="nome-bem"><h3>{{ bem.nm_bem }}</h3></div>
                                <h4>{{ bem.vl_bem | money }}</h4>
                            </div>
                        </div>
                    </td>
                    <td v-if="condicao_venda.st_situacao === 'A'">
                        <p class="font-weight-bold mb-0 text--dark">Parcela</p>
                    </td>
                    <td class="text-center selecao-bens-politica" v-for="prazo in prazos_disponiveis.map((item) => item.prazo)"
                        :key="prazo">
                        <!-- Se é grupo em andamento, tem até dois valores de parcela, um pra furo outro pra diluição-->
                        <template v-if="condicao_venda.st_situacao === 'A'">
                            <div class="d-flex justify-center">
                                <div v-if="get(bem, `prazos_diluicao.${prazo}.vl_fisica`, 0) !==
                                    get(bem, `prazos_furo.${prazo}.vl_fisica`, 0)
                                " class="d-flex flex-column text-left justify-space-between">
                                    <p class="font-weight-bold mb-0 mr-3 text--dark">Furo</p>
                                    <p class="font-weight-bold mb-0 mr-3 text--dark">Diluição</p>
                                </div>
                                <div class="d-flex flex-column justify-space-between" style="margin-top: -5px;">
                                    <div class="flex">
                                        <span v-if="bem.prazos_furo[prazo] &&
                                            bem.prazos_furo[prazo].vl_fisica
                                        ">
                                            <m-radio :is-custom-animation="true" :label="money(bem.prazos_furo[prazo].vl_fisica)" :radio-value="{
                                                id_bem: bem.id_bem,
                                                pz_comercializacao: prazo,
                                                st_tipo_venda: 'F',
                                                vl_bem: bem.vl_bem,
                                                vl_parcela: bem.prazos_furo[prazo].vl_fisica,
                                                nm_bem: bem.nm_bem,
                                                id_taxa_plano: bem.prazos_furo[prazo].id_taxa_plano,
                                                opcao_furo: bem.prazos_furo[prazo].opcao_furo,
                                                id_tipo_venda: bem.id_tipo_venda,
                                                id_produto: bem.id_produto,
                                                cd_bem: bem.cd_bem,
                                            }" v-model="bemEPrazoSelecionado" />
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="flex" v-if="get(bem, `prazos_diluicao.${prazo}.vl_fisica`, 0) !==
                                        get(bem, `prazos_furo.${prazo}.vl_fisica`, 1)
                                    ">
                                        <span v-if="bem.prazos_diluicao[prazo] &&
                                            bem.prazos_diluicao[prazo].vl_fisica
                                        ">
                                            <m-radio :is-custom-animation="true" :label="money(bem.prazos_diluicao[prazo].vl_fisica)"
                                                     :radio-value="{
                                                         id_bem: bem.id_bem,
                                                         pz_comercializacao: prazo,
                                                         st_tipo_venda: 'R',
                                                         vl_bem: bem.vl_bem,
                                                         vl_parcela: bem.prazos_diluicao[prazo].vl_fisica,
                                                         nm_bem: bem.nm_bem,
                                                         id_taxa_plano:
                                                             bem.prazos_diluicao[prazo].id_taxa_plano,
                                                         opcao_furo: bem.prazos_diluicao[prazo].opcao_furo,
                                                         id_tipo_venda: bem.id_tipo_venda,
                                                         id_produto: bem.id_produto,
                                                         cd_bem: bem.cd_bem,
                                                     }" v-model="bemEPrazoSelecionado" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <span v-if="bem.prazos[prazo] && bem.prazos[prazo].vl_fisica">
                                <m-radio :is-custom-animation="true" :label="money(bem.prazos[prazo].vl_fisica)" :radio-value="{
                                    id_bem: bem.id_bem,
                                    pz_comercializacao: prazo,
                                    st_tipo_venda: null,
                                    vl_bem: bem.vl_bem,
                                    vl_parcela: bem.prazos[prazo].vl_fisica,
                                    nm_bem: bem.nm_bem,
                                    id_taxa_plano: bem.id_taxa_plano,
                                    id_tipo_venda: bem.id_tipo_venda,
                                    id_produto: bem.id_produto,
                                    cd_bem: bem.cd_bem,
                                }" v-model="bemEPrazoSelecionado" />
                            </span>
                            <span v-else>-</span>
                        </template>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <div class="d-flex justify-space-between mt-5">
            <v-btn color="secondary" class="mr-4" @click="voltar">Voltar</v-btn>
            <v-tooltip top v-if="somente_reserva">
                <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                        <v-btn v-bind="attrs" color="primary" :disabled="somente_reserva || bemEPrazoSelecionado.id_bem === null || somente_reserva === null"
                               @click="abrirDialogCotas"
                               class="tooltip-btn">
                            Reservar
                        </v-btn>
                    </div>
                </template>
                <span>Esse grupo está disponível apenas para reservas, caso deseje reservar, vá até o menu "Reservas"!</span>
            </v-tooltip>
            <v-btn v-else color="primary" :disabled="bemEPrazoSelecionado.id_bem === null || somente_reserva === null"
                   @click="realizarVenda">
                Prosseguir com a venda
            </v-btn>
        </div>

        <DialogListagemCotas v-model="dialog_cotas_disponiveis" :dados="dados_reserva" show-back-button
                             @voltar="voltarDialogCotas" @utilizarReserva="utilizarReserva" />
    </v-container>
</template>

<script>
  import {
    alert,
    notification,
    getNomeEmpresaPorIdEmpresa,
    getComissionadoNormalized
  } from '@/plugins/helpers'
  import { money } from '@/plugins/formatters'
  import {
    OrigemReserva,
    SituacaoGrupo,
    TipoNegociacao
  } from '@/plugins/constants'
  import DialogListagemCotas from '@/dialogs/DialogListagemCotas'
  import { mapState } from 'vuex'
  import { get } from 'lodash'
  import AditamentoButton from '@/components/AditamentoButton.vue'
  import StepperPoliticaVendas from '../../components/politica-vendas/StepperPoliticaVendas.vue'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import conferirIntegridadeIniciarVenda from '../../mixins/CommercialHierarchy/conferirIntegridadeIniciarVenda'
  import { AlertTypes } from '../../plugins/alerts_types'
  import { SituacaoGrupoNewcon } from '../../plugins/constants'

  export default {
    name: 'SelecionarBemPoliticaVendas',
    components: { DialogListagemCotas, AditamentoButton, StepperPoliticaVendas },
    directives: {
      resize: {
        inserted (el, binding) {
          const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
              binding.value(entry.target)
            }
          })
          resizeObserver.observe(el)
        }
      }
    },
    mixins: [conferirIntegridadeIniciarVenda],
    data: () => ({
      estilosScrollBar: {
        '--marginScrollLeft': 0
      },
      ordenar: [
        'Código do bem (Crescente)',
        'Código do bem (Decrescente)',
        'Nome do bem (Crescente)',
        'Nome do bem (Decrescente)',
        'Valor do bem (Crescente)',
        'Valor do bem (Decrescente)'
      ],
      campo_ordenado: '',
      navegacaoConfirmada: false,
      pedido: {
        identificador_representante_tribanco: null,
        grupos_originais: null,
        plano: {
          id_plano_venda: 0,
          id_taxa_plano: 9,
          situacao_grupo: SituacaoGrupo.Andamento,
          pz_restante: 0,
          prazo_comercializacao: 0,
          valor_parcela: 0.0,
          tipo_negociacao: TipoNegociacao.Furo,
          opcao_furo: '',
          cd_plano_venda: null,
          nm_plano_venda: null
        },
        bem: {
          nm_bem: null,
          id_bem: null,
          cd_bem: null
        },
        produto: {
          id_produto: null
        },
        fluxo_venda_atual: 'politica_vendas',
        multiplicador_cota_habilitado_na_venda: false,
        flavor_atual: null
      },
      condicao_venda: {
        cd_bem: null,
        cd_grupo: null,
        nm_plano_venda: null,
        cd_plano_venda: null,
        num_maximo_cotas: null,
        vagas: null,
        assembleias_realizadas: null,
        credito_menor: null,
        credito_maior: null,
        categoria: null,
        id_plano_venda: null,
        id_grupo: null,
        id_produto: null,
        prazos: [],
        permite_reservar: null,
        id_bem: null,
        id_reserva: null,
        st_situacao: null,
        pz_comercializacao: null,
        modalidade_selecionada_index: null,
        id_empresa: null
      },
      bemEPrazoSelecionado: {
        id_bem: null,
        pz_comercializacao: null,
        st_tipo_venda: null,
        vl_bem: null,
        vl_parcela: null,
        nm_bem: null,
        id_taxa_plano: 0,
        id_tipo_venda: 0,
        cd_bem: null,
        opcao_furo: null
      },
      bens: [],
      dados_reserva: {
        ID_Empresa: null,
        ID_Bem: 0,
        ID_Produto: null,
        ID_Plano_Venda: null,
        ID_Tipo_Venda: 0,
        ID_Ponto_Venda: null,
        ID_Comissionado: null,
        ID_Grupo: null,
        PZ_Comercializacao: 0,
        CD_Cota: 0,
        ID_Filial_Venda: null,
        ST_Reserva: '',
        CD_Grupo: null,
        origem: OrigemReserva.PoliticaVendas
      },
      dialog_cotas_disponiveis: false,
      somente_reserva: null,
      filters: {
        nome_bem: '',
        vl_parcela_max: 0,
        vl_parcela_min: 0,
        vl_bem_max: 0,
        vl_bem_min: 0
      },
      permite_reservar: true,
      modalidades: [],
      bem_selecionado_tabela: null,
      permite_flavor_todos_produtos: false,
      administradora: ''
    }),
    computed: {
      cssProps () {
        return {
          ...this.estilosScrollBar
        }
      },
      prazos_disponiveis () {
        return this.condicao_venda.prazos.filter(
          (item) => item.furo > 0 && item.furo !== 'NÃO' && item.furo !== '-'
        )
      },
      ...mapState([
        'id_empresa',
        'id_ponto_venda',
        'id_comissionado_venda',
        'id_unidade_negocio',
        'produtos',
        'jornada_venda'
      ]),
      produtos_permitidos () {
        return this.$session.get('produtos').map((produto) => produto.ID_Produto)
      }
    },
    async mounted () {
      this.verificarSePodeProsseguirVenda()
      this.pedido.flavor_atual = this.$session.get('flavor') || null
      this.permite_flavor_todos_produtos = this.$session.get('permite_venda_todos_produtos')
      this.pedido.multiplicador_cota_habilitado_na_venda = this.$session.get('permite_multiplicar_cota')
      this.condicao_venda = this.$route.params
      if (
        this.$route.params.bem_selecionado_tabela !== null &&
        this.$route.params.bem_selecionado_tabela.id_bem > 0
      ) {
        this.bem_selecionado_tabela = this.$route.params.bem_selecionado_tabela
      }

      if (
        this.$route.params.id_reserva !== undefined &&
        this.$route.params.id_reserva > 0
      ) {
        this.getPolitica(this.$route.params)
      }
      // Checa se o usuário está vindo da tela de tabela de política, e não digitando a URL diretamente
      if (Object.keys(this.condicao_venda).length > 0) {
        await this.getSomenteReserva()

        if (this.condicao_venda.cd_bem) {
          this.filters.nome_bem = this.condicao_venda.cd_bem
        }

        await this.getSituacaoGrupo()
        this.getPlanoVenda(this.condicao_venda.id_plano_venda)
        if (this.prazos_disponiveis.length > 0) {
          this.carregarBens()
        } else {
          alert(
            'Não existem prazos disponíveis para o grupo e plano selecionado'
          )
        }
      } else {
        // noinspection JSCheckFunctionSignatures,JSIgnoredPromiseFromCall
        this.$router.replace({
          name: 'politica-vendas',
          params: { nao_perguntar: true }
        })
      }
    },
    methods: {
      onVoltarEtapa (step) {
        if (step === 1) {
          this.navegacaoConfirmada = true
          this.$router.push({
            name: 'politica-vendas',
            params: {
              filtro: this.condicao_venda.filtro,
              modalidade_selecionada_index: this.condicao_venda.modalidade_selecionada_index,
              nao_perguntar: true,
              bem_selecionado_tabela: this.bem_selecionado_tabela
            }
          })
        }
      },
      ajustarTamanhosResponsivosDoDataTable () {
        const headerDosElementosFixados = document.querySelector('#fixed-header')

        if (headerDosElementosFixados) {
          const widthElementosFixados = headerDosElementosFixados.offsetWidth
          this.estilosScrollBar['--marginScrollLeft'] = widthElementosFixados + 'px'
        }
      },
      async realizarVenda () {
        const filial = this.$session.get('filial')

        if (!this.pedido.id_regiao_fiscal) this.pedido.id_regiao_fiscal = 1
        if (!this.pedido.id_empresa) this.pedido.id_empresa = filial.ID_Empresa || this.$session.get('id_empresa')
        if (!this.pedido.id_filial) { this.pedido.id_filial = filial.ID_Filial_Venda }
        if (!this.pedido.nome_filial) { this.pedido.nome_filial = filial.NM_Filial_Venda }
        if (!this.pedido.cd_filial) { this.pedido.cd_filial = filial.CD_Filial_Venda }
        this.pedido.id_usuario = this.$session.get('id_usuario')
        const comissionadoData = getComissionadoNormalized(this.$session.get('id_comissionado_venda'), this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
        this.pedido.id_comissionado = comissionadoData.id_comissionado
        this.pedido.cd_comissionado = comissionadoData.cd_comissionado
        this.pedido.nm_comissionado = comissionadoData.nm_comissionado
        this.pedido.id_ponto_venda = this.$session.get('id_ponto_venda')
        this.pedido.identificador_representante_tribanco = this.$session.get(
          'identificador_representante_tribanco'
        )

        this.pedido.plano.prazo_comercializacao = this.bemEPrazoSelecionado.pz_comercializacao
        this.pedido.plano.valor_parcela = this.bemEPrazoSelecionado.vl_parcela
        this.pedido.plano.situacao_grupo = this.condicao_venda.st_situacao === SituacaoGrupoNewcon.Formacao ? SituacaoGrupo.Formacao : SituacaoGrupo.Andamento
        this.pedido.id_grupo = this.condicao_venda.id_grupo
        this.pedido.cd_grupo = this.condicao_venda.cd_grupo
        this.pedido.nome_bem = this.bemEPrazoSelecionado.nm_bem
        this.pedido.cd_bem = this.bemEPrazoSelecionado.cd_bem
        this.pedido.id_plano_venda = this.condicao_venda.id_plano_venda
        this.pedido.plano.id_plano_venda = this.condicao_venda.id_plano_venda
        this.pedido.plano.nm_plano_venda = this.condicao_venda.nm_plano_venda
        this.pedido.plano.cd_plano_venda = this.condicao_venda.cd_plano_venda
        this.pedido.produto.id_produto = this.bemEPrazoSelecionado.id_produto
        this.pedido.id_produto = this.bemEPrazoSelecionado.id_produto
        this.pedido.id_bem = this.bemEPrazoSelecionado.id_bem
        this.pedido.valor_bem = this.bemEPrazoSelecionado.vl_bem
        this.pedido.id_tipo_venda = this.bemEPrazoSelecionado.id_tipo_venda
        this.pedido.id_taxa_plano = this.bemEPrazoSelecionado.id_taxa_plano
        this.pedido.plano.id_taxa_plano = this.bemEPrazoSelecionado.id_taxa_plano
        this.pedido.dados_politica_vendas = this.condicao_venda
        this.pedido.id_empresa_venda_logada = this.id_empresa
        this.pedido.id_unidade_negocio = this.id_unidade_negocio
        this.pedido.opcao_furo = this.bemEPrazoSelecionado.opcao_furo
        this.pedido.backoffice = this.$session.get('vendas_backoffice')
        this.pedido.origem_acesso = this.$session.get('origem_acesso')
        this.pedido.flavor_atual = this.$session.get('flavor')
        this.pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
        this.pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')
        const ambiente = this.$session.get('ambiente')
        if (ambiente && ambiente.unidade_condicoes_venda) {
          this.pedido.unidade_condicoes_venda = ambiente.unidade_condicoes_venda
        }
        const id_produto = this.bemEPrazoSelecionado?.id_produto ? this.bemEPrazoSelecionado.id_produto : this.bem_selecionado_tabela.id_produto
        const produto = this.produtos.find((produto) => String(produto.ID_Produto) === String(id_produto))
        this.pedido.produto.cd_produto = produto.CD_Produto
        this.pedido.produto.nome_produto = produto.NM_Produto

        if (this.condicao_venda.id_reserva > 0) {
          this.pedido.id_reserva = this.condicao_venda.id_reserva
        }
        const id_regiao_fiscal = 1
        const prazos_parcelas = await this.$http.get('/compra/prazosparcelas', {
          params: {
            ...this.pedido.plano,
            id_bem: this.bemEPrazoSelecionado.id_bem,
            id_regiao_fiscal,
            id_reserva: this.pedido.id_reserva,
            id_grupo: this.condicao_venda.id_grupo,
            apenas_reserva: this.somente_reserva
          }
        }).then((response) => response.data)

        let res = await this.getCaracteristicas()
        let grupos_carac = res.data.CaracteristicaGrupo.CaracteristicaGrupo[0]
        this.pedido.grupo = {
          id_grupo: grupos_carac.ID_Grupo,
          cd_grupo: grupos_carac.CD_Grupo,
          taxa_adm: prazos_parcelas.grupos[0].PE_TA_Total,
          pe_lance_fixo: grupos_carac.PE_Lance_Fixo,
          pe_seguro: grupos_carac.PE_SG_F,
          dt_vencimento: grupos_carac.DT_Vencimento,
          dt_assembleia: grupos_carac.DT_Assembleia,
          qt_participantes: grupos_carac.QT_Participantes,
          id_tipo_venda: this.bemEPrazoSelecionado.id_tipo_venda,
          id_produto: this.pedido.produto.id_produto
        }

        this.pedido.plano.pz_restante = grupos_carac.PZ_Restante
        this.pedido.plano.pz_original = grupos_carac.PZ_Comercializacao

        if (this.bemEPrazoSelecionado.st_tipo_venda === 'F') {
          this.getOpcaoFuro(grupos_carac)
        } else if (this.bemEPrazoSelecionado.st_tipo_venda === 'R') {
          this.pedido.plano.opcao_furo = this.bemEPrazoSelecionado.opcao_furo
          this.pedido.plano.tipo_negociacao = 'diluido'
        }

        this.pedido.grupos_originais = prazos_parcelas.grupos_originais
        this.sendAnalytics()

        if (this.pedido.id_reserva > 0) {
          this.$http
            .post('/reserva/criar/venda', {
              ...this.pedido,
              ...this.$session.get('filial'),
              vl_parcela: this.pedido.vl_fisica,
              nome_bem: this.pedido.nm_bem
            })
            .then((result) => {
              this.pedido.id_pedido = result.data.id_pedido
              this.$router.push({
                name: 'iniciar-venda',
                params: {
                  ...this.pedido,
                  nao_perguntar: true,
                  modalidade_selecionada_index:
                    this.condicao_venda.modalidade_selecionada_index,
                  politica_vendas: true
                }
              })
            })
            .catch((err) =>
              notification(AlertTypes.ERROR, err, 'Não foi possível criar a venda para reserva completa!')
            )
        } else {
          this.navegacaoConfirmada = true
          // Garantir que valor da parcela está definido antes de enviar
          const vl_parcela = this.pedido.plano?.valor_parcela || this.bemEPrazoSelecionado?.vl_parcela
          const vl_parcela_com_seguro = this.pedido.plano?.vl_parcela_com_seguro || vl_parcela
          
          this.$http
            .post('/vendas', {
              ...this.pedido,
              vl_parcela: vl_parcela,
              vl_parcela_com_seguro: vl_parcela_com_seguro,
              vl_original: vl_parcela
            })
            .then((res) => {
              this.pedido.id_pedido = res.data.id_pedido
              // noinspection JSCheckFunctionSignatures
              this.$router.push({
                name: 'iniciar-venda',
                params: {
                  ...this.pedido,
                  nao_perguntar: true,
                  modalidade_selecionada_index:
                    this.condicao_venda.modalidade_selecionada_index,
                  politica_vendas: true
                }
              })
            })
            .catch((err) => {
              if (err.response && err.response.data && err.response.data.Msg_Erro) {
                notification(AlertTypes.ERROR, err.response.data.Msg_Erro, 'Não foi possível salvar a venda')
              } else {
                notification(AlertTypes.ERROR, err, 'Não foi possível salvar a venda')
              }
              this.navegacaoConfirmada = false
            })
        }
      },
      confirmReload (next) {
        alert({
          text: 'Tem certeza que deseja sair? Você perderá mudanças não salvas!',
          buttons: {
            'Cancelar': () => next(false),
            'Confirmar': () => {
              this.navegacaoConfirmada = true
              next()
            }
          }
        })
      },
      voltar () {
        alert({
          text: 'Tem certeza que deseja sair? Você perderá mudanças não salvas!',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => {
              this.navegacaoConfirmada = true
              this.$router.push({
                name: 'politica-vendas',
                params: {
                  filtro: this.condicao_venda.filtro,
                  modalidade_selecionada_index:
                    this.condicao_venda.modalidade_selecionada_index,
                  nao_perguntar: true,
                  bem_selecionado_tabela: this.bem_selecionado_tabela,
                  skip_preparacao: true
                }
              })
            }
          }
        })
      },
      sendAnalytics (reserve = false) {
        sendAnalyticsEvent(
          this.$gtag,
          reserve ? 'politica_venda_reservar_bem' : 'politica_venda_confirmar_bem',
          {
            grupo: this.condicao_venda.cd_grupo,
            plano_venda: `${this.condicao_venda.cd_plano_venda} - ${this.condicao_venda.nm_plano_venda}`,
            tipo_produto: this.condicao_venda.modalidades[this.condicao_venda.modalidade_selecionada_index].nome,
            cod_bem: this.bemEPrazoSelecionado.cd_bem,
            valor_bem: this.bemEPrazoSelecionado.vl_bem,
            valor_parcelas: this.bemEPrazoSelecionado.vl_parcela,
            tipo_grupo: this.pedido.plano.opcao_furo
          }
        )
      },
      getOpcaoFuro (caracteriscas) {
        let arredondamento = Math.ceil(caracteriscas.PZ_Comercializacao * 0.1)
        if (caracteriscas.PZ_Decorrido === 0) {
          this.pedido.plano.opcao_furo = 'furo_encerramento'
        } else if (caracteriscas.PZ_Decorrido > arredondamento) {
          this.pedido.plano.opcao_furo = 'furo_contemplacao'
        } else {
          this.pedido.plano.opcao_furo = 'furo_encerramento'
        }
      },
      async getSituacaoGrupo () {
        try {
          const res = await this.$http.get(
            `/grupo/situacao/${this.condicao_venda.id_grupo}`
          )
          if (typeof res.data.msg_erro !== 'undefined') {
            // noinspection ExceptionCaughtLocallyJS
            throw Error('Não foi possível buscar a situação do grupo')
          } else {
            this.condicao_venda.st_situacao = res.data.st_situacao
          }
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível buscar a situação do grupo')
          throw e
        }
      },
      async getCaracteristicas () {
        return this.$http.get('/grupos/caracteristicas', {
          params: {
            ID_Grupo: this.condicao_venda.id_grupo
          }
        })
      },
      async filtrar () {
        await this.getSomenteReserva()
        this.carregarBens()
      },
      async carregarBens () {
        try {
          const res = await this.$http.get('/politica_vendas/bens_prazos', {
            params: {
              id_grupo: this.condicao_venda.id_grupo,
              id_plano_venda: this.condicao_venda.id_plano_venda,
              st_situacao: this.condicao_venda.st_situacao,
              somente_reserva: this.somente_reserva,
              prazos: this.prazos_disponiveis.map((item) => item.prazo),
              filtro: this.filters,
              flavor: this.$session.get('flavor'),
              produtos: this.produtos_permitidos,
              id_empresa: this.$session.get('id_empresa'),
              id_unidade_negocio: this.$session.get('id_unidade_negocio'),
              permite_venda_todos_produtos: this.$session.get('permite_venda_todos_produtos') || 0
            }
          })
          this.bens = res.data

          if (!res.data || res.data.length === 0) {
            notification(AlertTypes.ERROR, 'Nenhum bem encontrado para as condições selecionadas.')
          }
        } catch (e) {
          notification(AlertTypes.ERROR, 'Ocorreu um erro ao buscar a listagem. Tente novamente mais tarde e se o erro persistir, entre em contato com a Área de Suporte.')
        }
      },
      async limpar () {
        this.limparFiltros()
        await this.getSomenteReserva()
        this.carregarBens()
      },
      limparFiltros () {
        this.filters = {
          nome_bem: '',
          vl_parcela_max: 0,
          vl_parcela_min: 0,
          vl_bem_max: 0,
          vl_bem_min: 0
        }
      },
      abrirDialogCotas () {
        this.dados_reserva.ID_Produto = this.condicao_venda.id_produto
        this.dados_reserva.ID_Plano_Venda = this.condicao_venda.id_plano_venda
        this.dados_reserva.ID_Grupo = this.condicao_venda.id_grupo
        this.dados_reserva.CD_Grupo = this.condicao_venda.cd_grupo
        this.dados_reserva.ID_Empresa = this.id_empresa
        this.dados_reserva.ID_Ponto_Venda = this.id_ponto_venda
        this.dados_reserva.ID_Comissionado = this.id_comissionado_venda
        this.dados_reserva.ID_Filial_Venda = this.$session.get('filial').ID_Filial_Venda
        if (this.bem_selecionado) {
          this.dados_reserva.ID_Bem = this.bem_selecionado.id_bem
        }

        this.sendAnalytics(true)
        this.dialog_cotas_disponiveis = true
      },
      voltarDialogCotas () {
        this.dialog_cotas_disponiveis = false
      },
      utilizarReserva (reserva) {
        this.pedido.id_reserva = reserva.ID_Reserva
        this.realizarVenda()
      },
      async getSomenteReserva () {
        if (this.somente_reserva !== null) {
          return
        }
        try {
          const resp = await this.$http.get('/politica_vendas/somente_reserva', {
            params: {
              id_grupo: this.condicao_venda.id_grupo,
              id_plano_venda: this.condicao_venda.id_plano_venda,
              id_bem: this.bem_selecionado_tabela?.id_bem || 0,
              situcacao_grupo: this.condicao_venda.st_situacao
            }
          })
          const { data } = resp
          this.somente_reserva = data.somente_reserva
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível carregar a opção de reserva')
          throw e
        }
      },
      getPlanoVenda (id_plano) {
        this.$http
          .get('/politica_vendas/get_plano', {
            params: {
              id_plano: id_plano
            }
          })
          .then((res) => {
            this.condicao_venda.cd_plano_venda = res.data.cd_plano_venda
          })
      },
      getPolitica (reserva) {
        this.$http
          .get('/politica_vendas/get_prazo', {
            params: {
              id_plano_venda: reserva.id_plano_venda,
              id_grupo: reserva.id_grupo
            }
          })
          .then((res) => {
            let resposta = res.data.items[0]
            this.condicao_venda.assembleias_realizadas =
              resposta.assembleias_realizadas
            this.condicao_venda.cd_bem = resposta.cd_bem
            this.condicao_venda.num_maximo_cotas = resposta.num_maximo_cotas
            this.condicao_venda.vagas = resposta.vagas
            this.condicao_venda.categoria = resposta.categoria
            this.condicao_venda.credito_maior = resposta.credito_maior
            this.condicao_venda.credito_menor = resposta.credito_menor
            this.condicao_venda.prazos = resposta.prazos
          })
      },
      getAdministradora () {
        this.administradora = getNomeEmpresaPorIdEmpresa(
          this.condicao_venda.id_empresa
        )
        if (this.permite_flavor_todos_produtos) {
          return (
            this.condicao_venda.cd_grupo +
            ' - Administrado por ' +
            this.administradora
          )
        } else {
          return this.condicao_venda.cd_grupo
        }
      },
      money: money,
      ordenarValorBemCrescente () {
        if (this.campo_ordenado === 'Valor do bem (Crescente)') {
          this.bens.sort((a, b) => (a.vl_bem > b.vl_bem ? 1 : -1))
        } else if (this.campo_ordenado === 'Valor do bem (Decrescente)') {
          this.bens.sort((a, b) => (a.vl_bem < b.vl_bem ? 1 : -1))
        } else if (this.campo_ordenado === 'Código do bem (Crescente)') {
          this.bens.sort((a, b) => (a.cd_bem > b.cd_bem ? 1 : -1))
        } else if (this.campo_ordenado === 'Código do bem (Decrescente)') {
          this.bens.sort((a, b) => (a.cd_bem < b.cd_bem ? 1 : -1))
        } else if (this.campo_ordenado === 'Nome do bem (Crescente)') {
          this.bens.sort((a, b) => (a.nm_bem > b.nm_bem ? 1 : -1))
        } else if (this.campo_ordenado === 'Nome do bem (Decrescente)') {
          this.bens.sort((a, b) => (a.nm_bem < b.nm_bem ? 1 : -1))
        }
      },
      get
    },
    beforeRouteLeave (to, from, next) {
      if (this.navegacaoConfirmada || !from.name) {
        next()
      } else if (to.name === 'logout' || (!to.params.nao_perguntar && !(this.is_usuario_logado_hierarquia && to.query.redirecionamentoPainelLateral))) {
        next()
      } else {
        this.confirmReload(next)
      }
    }
  }
</script>

<style lang="scss" scoped>
.separator {
  border-bottom: 1px solid var(--gray);
}

thead {
  background: #f8f8f8;
  z-index: 5;

  tr td {
    border-bottom: 1px solid var(--gray);
    font-weight: bold;
    color: var(--dark);
  }

  tr:nth-child(1) th {
    box-shadow: none;
  }
}

.table-bem-politica-vendas {
  background-color: #f8f8f8;

  .fixed-column {
    position: sticky;
    left: 0;
    z-index: 2;
    border-right: 1px solid var(--border_gray);
    background: inherit;
  }

  .table-bem-politica-vendas_theader {
    z-index: 5;
    position: sticky;
    background-color: var(--darkwhite);
    top: 0px;

    .no-box-shadow{
      box-shadow:none;
    }
    tr {
      background-color: inherit !important;

      th {
        background-color: inherit !important;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-track {
    background-color: var(--darkwhite);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--primary);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  $espacamento_scrollbar_vertical_top_tela_grande: 95px;
  $espacamento_scrollbar_horizontal_responsiva: var(--marginScrollLeft);

  ::-webkit-scrollbar-track:vertical {
    background-color: var(--darkwhite);
    z-index: 1;
    margin-top: $espacamento_scrollbar_vertical_top_tela_grande;
  }

  ::-webkit-scrollbar-track:horizontal {
    background-color: var(--white);
    margin-left: $espacamento_scrollbar_horizontal_responsiva;

  }

  ::-webkit-scrollbar:horizontal {
    border-left: $espacamento_scrollbar_horizontal_responsiva solid var(--darkwhite);

  }

  @media (max-width: 1366px) {
    $espacamento_scrollbar_vertical_top_tela_media: 95px;

    ::-webkit-scrollbar-track:vertical {
      background-color: var(--darkwhite);
      z-index: 1;
      margin-top: $espacamento_scrollbar_vertical_top_tela_media;
    }

    ::-webkit-scrollbar-track:horizontal {
      margin-left: $espacamento_scrollbar_horizontal_responsiva;
    }

    ::-webkit-scrollbar:horizontal {
      border-left: $espacamento_scrollbar_horizontal_responsiva solid var(--darkwhite);
    }
  }
}

.img-bem {
  display: block;
  width: 110px;
  height: 65px;
  object-fit: contain;
  object-position: center;
}

.bem-item {
  h3 {
    color: var(--dark);
    text-transform: uppercase;
  }

  h4 {
    color: var(--primary);
  }
}

$max-width-descricao-bem : 20vw;
.nome-bem {
  width: 20vw;
  max-width: $max-width-descricao-bem;
  min-width:fit-content;

}
.nome-bem h3{
  word-break: break-word;
  max-width:$max-width-descricao-bem;
}

.label-prazos {
  text-align: center;
  margin: 0 0 0 50%;
}
</style>
<style>
.selecao-bens-politica .v-radio {
  margin-right: 0;
}

.table-bem-politica-vendas .v-data-table__wrapper {
  max-height: 70vh;
  overflow-y: auto;
}

.tooltip-btn {
  cursor: pointer !important;
}
</style>
